import type { ReactElement } from 'react';

interface IconProps {
  size?: number;
  className?: string;
  'aria-label'?: string;
  'aria-hidden'?: boolean;
}

export const HandBaggageIcon = ({
  size = 40,
  className,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
}: IconProps): ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    className={className}
    aria-label={ariaLabel}
    aria-hidden={ariaHidden}
    role={ariaLabel ? 'img' : undefined}
  >
    <path
      d="M34 0H6C2.68629 0 0 2.68629 0 6V34C0 37.3137 2.68629 40 6 40H34C37.3137 40 40 37.3137 40 34V6C40 2.68629 37.3137 0 34 0Z"
      fill="#F4F8FF"
    />
    <path
      d="M17.2656 11.062H22.7366C23.0018 11.062 23.2562 11.1674 23.4437 11.3549C23.6313 11.5424 23.7366 11.7968 23.7366 12.062V14.798H16.2656V12.062C16.2656 11.7968 16.371 11.5424 16.5585 11.3549C16.7461 11.1674 17.0004 11.062 17.2656 11.062Z"
      fill="white"
    />
    <path
      d="M17.1996 11.996V13.862H22.7996V11.996H17.1996ZM17.1996 11.062H22.7996C23.0473 11.062 23.2849 11.1604 23.4601 11.3356C23.6352 11.5107 23.7336 11.7483 23.7336 11.996V14.796H16.2656V11.996C16.2656 11.7483 16.364 11.5107 16.5392 11.3356C16.7143 11.1604 16.9519 11.062 17.1996 11.062Z"
      fill="#393939"
    />
    <path
      d="M17.2656 11.5291H22.7366C23.0018 11.5291 23.2562 11.6344 23.4437 11.8219C23.6313 12.0095 23.7366 12.2638 23.7366 12.5291V14.7981H16.2656V12.5291C16.2656 12.2638 16.371 12.0095 16.5585 11.8219C16.7461 11.6344 17.0004 11.5291 17.2656 11.5291Z"
      fill="#F4F8FF"
    />
    <path
      d="M17.2 12.324V13.808H22.8V12.324H17.2ZM17.2 11.334H22.8C23.0551 11.3416 23.2967 11.4501 23.4719 11.6357C23.647 11.8213 23.7413 12.0689 23.734 12.324V14.797H16.266V12.324C16.2587 12.0689 16.353 11.8213 16.5282 11.6357C16.7033 11.4501 16.9449 11.3416 17.2 11.334Z"
      fill="#393939"
    />
    <path
      d="M27.3382 13.863H12.6602C11.5556 13.863 10.6602 14.7585 10.6602 15.863V24.938C10.6602 26.0426 11.5556 26.938 12.6602 26.938H27.3382C28.4427 26.938 29.3382 26.0426 29.3382 24.938V15.863C29.3382 14.7585 28.4427 13.863 27.3382 13.863Z"
      fill="#8DD3F0"
    />
    <path
      d="M12.5282 14.797C12.2805 14.7973 12.0431 14.8958 11.868 15.0709C11.6929 15.246 11.5944 15.4834 11.5942 15.731V25.07C11.5944 25.3177 11.6929 25.5551 11.868 25.7302C12.0431 25.9053 12.2805 26.0038 12.5282 26.004H27.4702C27.7178 26.0038 27.9552 25.9053 28.1303 25.7302C28.3054 25.5551 28.4039 25.3177 28.4042 25.07V15.731C28.4039 15.4834 28.3054 15.246 28.1303 15.0709C27.9552 14.8958 27.7178 14.7973 27.4702 14.797H12.5282ZM12.5282 13.863H27.4702C27.9656 13.863 28.4407 14.0598 28.791 14.4102C29.1413 14.7605 29.3382 15.2356 29.3382 15.731V25.07C29.3382 25.5655 29.1413 26.0406 28.791 26.3909C28.4407 26.7412 27.9656 26.938 27.4702 26.938H12.5282C12.0327 26.938 11.5576 26.7412 11.2073 26.3909C10.857 26.0406 10.6602 25.5655 10.6602 25.07V15.731C10.6602 15.2356 10.857 14.7605 11.2073 14.4102C11.5576 14.0598 12.0327 13.863 12.5282 13.863Z"
      fill="#393939"
    />
    <path
      d="M24.6055 14.626V26.269C24.6335 26.3954 24.7038 26.5085 24.8048 26.5895C24.9058 26.6706 25.0315 26.7148 25.161 26.7148C25.2905 26.7148 25.4161 26.6706 25.5171 26.5895C25.6181 26.5085 25.6884 26.3954 25.7165 26.269V14.626C25.6884 14.4995 25.6181 14.3865 25.5171 14.3054C25.4161 14.2244 25.2905 14.1802 25.161 14.1802C25.0315 14.1802 24.9058 14.2244 24.8048 14.3054C24.7038 14.3865 24.6335 14.4995 24.6055 14.626Z"
      fill="#393939"
    />
    <path
      d="M14.2812 14.626V26.269C14.3093 26.3954 14.3796 26.5085 14.4806 26.5895C14.5816 26.6706 14.7073 26.7148 14.8368 26.7148C14.9663 26.7148 15.0919 26.6706 15.1929 26.5895C15.2939 26.5085 15.3642 26.3954 15.3923 26.269V14.626C15.3642 14.4995 15.2939 14.3865 15.1929 14.3054C15.0919 14.2244 14.9663 14.1802 14.8368 14.1802C14.7073 14.1802 14.5816 14.2244 14.4806 14.3054C14.3796 14.3865 14.3093 14.4995 14.2812 14.626Z"
      fill="#393939"
    />
  </svg>
);
